import * as React from "react";

import '../styles/MainTypes.css';
import '../styles/Button.css';

import Dropdown from "./Dropdown";
import AttrTree from "./AttrTree";
import Config from "../Config";
import MetamodelStore from "../resources/data/MetamodelStore";
import WordInsertions from "../utils/WordInsertions";
import JsonTreeDataCreator from "../utils/JsonTreeDataCreator";
import ModalTableAttrs from "./modals/ModalTableAttrs";
import StateGlobal from "../StateGlobal";
import tableIcon from '../../assets/icons/table-list.svg'

/**
 * This component is very similar (but simpler) to MainModelTypes
 */
export default class MainObjectTypes extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      aMetaObjectTypes: [],
      sSelectedObjectTypeId: '',
      aSelectedMetaObjectTypeData: {},
      bSelectedSuperObject: false
    };

    this.modals = {
      objectAttrs: React.createRef()
    };

    Config.getConfig();
  }

  setActive = () =>
  {
    this.setState({
      bActive: true
    })
  }

  loadMetaObjectTypes = () =>
  {
    try
    {
      var aMetaObjectTypes = MetamodelStore.getInstance().getMetaObjectTypesVisible(false, true);
      if (aMetaObjectTypes)
      {
        this.setState({
          aMetaObjectTypes: aMetaObjectTypes
        });
      }
    } catch (error)
    {
      console.error(error.message)
    }
  }

  loadMetaObjectTypeData = (sID) =>
  {
    try
    {
      var aMetaObjectTypeData = MetamodelStore.getInstance().getMetaObjectType(sID);
      return aMetaObjectTypeData;
    } catch (error)
    {
      console.error(error.message);
      return null;
    }
  }

  toggleModal = (sModalKey) =>
  {
    if (Object.hasOwnProperty.call(this.modals, sModalKey))
    {
      this.modals[sModalKey].current.toggleModal();
    }
  }

  refreshObjectSelection = (sID) =>
  {
    for (const key in this.state.aMetaObjectTypes)
    {
      this.state.aMetaObjectTypes[key].selected = false;
    }
    this.state.aMetaObjectTypes[sID].selected = true;

    var aMetaObjectTypeData = this.loadMetaObjectTypeData(sID);

    var isSuper = false;
    if (Object.hasOwnProperty.call(aMetaObjectTypeData, 'isSuper') && aMetaObjectTypeData.isSuper)
    {
      isSuper = true;
    }

    this.setState({
      sSelectedObjectTypeId: sID,
      aSelectedMetaObjectTypeData: aMetaObjectTypeData,
      bSelectedSuperObject: isSuper
    });
  }

  getJsonTreeModelProp = (sTopLvlLabel, isSuper) =>
  {
    if (Object.hasOwnProperty.call(this.state.aSelectedMetaObjectTypeData, 'notebookStructure') || isSuper)
    {
      var aJsonTreeData = (isSuper
        ? JsonTreeDataCreator.superNotebookData('objects', null, true, true)
        : JsonTreeDataCreator.notebookData(this.state.aSelectedMetaObjectTypeData.notebookStructure, true));

      if (sTopLvlLabel)
      {
        return {
          [sTopLvlLabel]: aJsonTreeData
        };
      }
      return aJsonTreeData;
    }
    return null;
  }

  render()
  {
    if (!this.state.bActive)
    {
      return null;
    }

    var aJsonTreeAttrData = this.getJsonTreeModelProp(Config.strings.jsonTree.objectAttributesKey, this.state.bSelectedSuperObject);

    return (
      <div className="MainTypes">

        <Dropdown
          title={Config.strings.dropdowns.objectSelection}
          itemsList={Object.values(this.state.aMetaObjectTypes)}
          resetThenSet={this.refreshObjectSelection}
          openedAtCreation={true}
          type={"Object"}
        />

        {(0 < Object.keys(this.state.aSelectedMetaObjectTypeData).length) &&
          <div className="MainTypes__container">
            <div className="MainTypes__loopContent">
              <button className="wrcButton wrcButton--dark" onClick={
                WordInsertions.objectLoop.bind(this,
                  this.state.bSelectedSuperObject
                    ? null
                    : {
                      sName: this.state.aSelectedMetaObjectTypeData.sName,
                    })
              }>
                {
                  this.state.bSelectedSuperObject
                    ? Config.strings.buttonLabels.loopObjects
                    : Config.strings.buttonLabels.loopObjectsSpecific.replace(/%s/g, Config.getLangName(this.state.aSelectedMetaObjectTypeData))
                }
              </button>

              <div className="MainTypes__sectionBordered">
                <AttrTree
                  treeData={aJsonTreeAttrData}
                  dataType="objects"
                  isInnerLoop={false}
                  preventRelationNotebook={true}
                />
              </div>
              {aJsonTreeAttrData && Object.hasOwnProperty.call(aJsonTreeAttrData, Config.strings.jsonTree.objectAttributesKey) &&
                <div>
                  < ModalTableAttrs
                    aNotebook={aJsonTreeAttrData[Config.strings.jsonTree.objectAttributesKey]}
                    sTitle={Config.strings.modals.objectAttrs.sTitle}
                    ref={this.modals.objectAttrs}
                  />
                  <button className="wrcButton wrcButton--secondary wrcButton--secondary_icon" onClick={this.toggleModal.bind(this, 'objectAttrs')}>
                    <img src={tableIcon} height={24}/>
                    {Config.strings.buttonLabels.insertTableObjAttr}
                  </button>
                </div>
              }
            </div>
          </div>}

      </div>
    );
  }
}
